module.exports = __webpack_public_path__ + "images/gallery-46a99fc58413214ef26f6c62574b1b3e.jpg";